// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"e691364d","67":"e691364d","474":"af8fb1b2","668":"e691364d","890":"b8478e30"}[chunkId] + ".chunk.css";
};